import * as React from 'react';
import {useEffect, useRef, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText
} from '@mui/material';
import {findCode, fullCopy, printVariable} from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import {Grid} from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";

// quill
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
const TeacherNoticePartView = ({record, dialogHandler, callback}) =>  {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()

  // redux
  const codes = useSelector(state => state.codeReducer);
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const editorRef = useRef();
  
  const [attchList, set_attchList] = useState([])

  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return 
    }
    else {
      dialogHandler[1](false)
    }
  }


  const fetchAttchList = async () => {
    const url = `/notice/attchs/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    set_attchList(records)
  }

  const onLoad = async () => {
    await fetchAttchList()
  }

  useEffect(() => {
    onLoad()
  },[])

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]}  onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            [{findCode(codes,'SA24', record.catCode)?.name}] {record.title}
          </Typography>
          {
            record.catCode === 'S002' ? (
              <Typography variant='body1' align='center'>
                {record.sTime} ~ {record.eTime}
              </Typography>
            ): null
          }

          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <br/>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ReactQuill
                theme="bubble"
                defaultValue={record.content}
                readOnly={true}
                name={'content'}
              />
            </Grid>
            <Grid item xs={12} sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
              {
                attchList.length > 0 ? (
                  <>
                    <AttachFileOutlinedIcon style={{fontSize:'1em', }}/>
                    <Typography variant='body2'>첨부</Typography>
                  </>
                  
                ) : null
              }
            </Grid>
            <Grid item xs={12} sx={{display:'flex', flexDirection:'column'}}>
              
              {
                attchList.map((item, idx) =>(
                  <div key={idx} style={{display:'flex', flexDirection:'row'}}>
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center' }}>
                      <Typography variant='body2' style={{marginRight:5}} >
                        {item.name} 
                      </Typography>

                      <FileDownloadOutlinedIcon style={{fontSize:'1em', cursor:'pointer', marginLeft:10}} onClick={async () => {
                        const url = `/scm/repo/${item.fileLoc}`
                        try {
                          const response = await fetch(url);
                          if (!response.ok) throw new Error('Network response was not ok');
                          const blob = await response.blob();
                          const downloadUrl = window.URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.href = downloadUrl;
                          // link.download = item.fileLoc.split('/').pop(); // extract filename
                          link.download = item.name; // extract filename
                          document.body.appendChild(link);
                          link.click();
                          link.remove();
                          window.URL.revokeObjectURL(downloadUrl);
                        } catch (err) {
                          console.error('Download failed:', err);
                          alert('파일을 다운로드 할 수 없습니다.')
                        }
                        
                      }}/>

                    </div>
                  </div>
                ))
              }
            </Grid>
            
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
    </Fragment>
  )
}

export default TeacherNoticePartView